import React, { FC, HTMLAttributes, PropsWithChildren } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {}

const ClickEventPropagationBlocker: FC<PropsWithChildren<Props>> = ({ onClick, ...rest }) => {
  return (
    <div
      {...rest}
      onClick={(e): void => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.(e);
      }}
    />
  );
};

export default ClickEventPropagationBlocker;
